var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { list: true, "list--loading": _vm.loading } },
    [
      _c("Vuetable", {
        ref: "vuetable",
        attrs: {
          "api-url": "insights",
          fields: _vm.fields,
          css: _vm.css,
          "pagination-path": "meta",
          "http-fetch": _vm.fetch,
          "load-on-start": _vm.loadOnStart,
          "append-params": _vm.filters,
          "row-class": _vm.onRowClass,
          "min-rows": _vm.loading ? 10 : null,
          "no-data-template":
            _vm.loaded && !_vm.newOnly ? "No insights found" : "",
        },
        on: {
          "vuetable:pagination-data": _vm.onPaginationData,
          "vuetable:loading": _vm.onLoading,
          "vuetable:loaded": _vm.onLoaded,
          "vuetable-load-error": _vm.onLoadError,
        },
      }),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "list__error" }, [
            _c("span", { staticClass: "h2" }, [
              _vm._v("Unable to load insights."),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--link",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.load.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Retry")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.newOnly && _vm.empty
        ? _c(
            "div",
            { staticClass: "list__empty" },
            [
              _c("span", { staticClass: "h2" }, [
                _vm._v("You're all up to date!"),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "btn btn--link", attrs: { to: "/insights" } },
                [_vm._v("View all insights")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Pagination", {
        ref: "pagination",
        on: { "vuetable-pagination:change-page": _vm.onChangePage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }